import Swal from 'sweetalert2';
import { displayError } from '../../helpers';
import { getHTMLForTablePopup } from '../../utils/PopupUtils';
import { formatQty } from '../../utils/listSummaryUtils';
import { openPdfResponse } from '../../utils/openPdfInApp';
import { printBatchReport, printDeliveryChallan } from '../../services/DeliveryChallanServices';

const actionIconButton = (className, dcId, title, backgroundColor) => (
  `<button type="button" class="${className}" data-dc-id="${dcId}" title="${title}" aria-label="${title}" style="display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;margin:1px;padding:0;border:none;border-radius:4px;background:${backgroundColor};cursor:pointer;vertical-align:middle;">
    <i class="fa fa-print" aria-hidden="true" style="font-size:12px;color:#fff;"></i>
  </button>`
);

const attachPrintHandlers = (cookies, selector, printFn, fileName, errorTitle) => {
  document.querySelectorAll(selector).forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const deliveryId = btn.getAttribute('data-dc-id');
      if (!deliveryId) {
        return;
      }
      btn.disabled = true;
      const iconEl = btn.querySelector('i');
      if (iconEl) {
        iconEl.className = 'fa fa-spinner fa-spin';
      }
      printFn(cookies, deliveryId)
        .then((response) => {
          openPdfResponse(response, {
            title: fileName,
            downloadFileName: `${fileName.toLowerCase().replace(/\s+/g, '_')}.pdf`,
          });
        })
        .catch((error) => {
          displayError(error?.response?.data ?? error.message, errorTitle);
        })
        .finally(() => {
          btn.disabled = false;
          if (iconEl) {
            iconEl.className = 'fa fa-print';
          }
        });
    });
  });
};

export function showMoistureLinkedDcPopup(row, cookies) {
  const details = row?.delivery_challans || [];
  if (!details.length) {
    Swal.fire('No delivery challans linked to this moisture correction.', '', 'info');
    return;
  }

  const popupRows = details.map((item) => ({
    ...item,
    dc_qty_display: formatQty(item.dc_qty),
    actions: item.id
      ? `<span style="display:inline-flex;align-items:center;white-space:nowrap;">
          ${actionIconButton('mc-dc-print-btn', item.id, 'Print Delivery Challan', '#198754')}
          ${actionIconButton('mc-br-print-btn', item.id, 'Print Batch Report', '#f59e0b')}
         </span>`
      : '',
  }));

  const totalQty = details.reduce((sum, item) => sum + (Number(item.dc_qty) || 0), 0);
  const title = [row.mc_no, row.mc_date_display, row.mc_time].filter(Boolean).join(' | ');

  Swal.fire({
    title: 'List of Delivery Challans with this Moisture Correction',
    html: getHTMLForTablePopup(
      title || 'Moisture Correction',
      [
        { key: 'delivery_challan_no', label: 'DC NO', headerAlign: 'center' },
        { key: 'delivery_challan_date', label: 'DATE', headerAlign: 'center' },
        { key: 'delivery_challan_time', label: 'TIME', headerAlign: 'center' },
        { key: 'customer_name', label: 'CUSTOMER', headerAlign: 'center' },
        { key: 'site_name', label: 'SITE', headerAlign: 'center' },
        { key: 'grade', label: 'GRADE', headerAlign: 'center' },
        { key: 'vehicle_no', label: 'VEHICLE', headerAlign: 'center' },
        { key: 'dc_qty_display', label: 'QTY', align: 'right', headerAlign: 'center' },
        { key: 'actions', label: 'ACTION', align: 'center', headerAlign: 'center' },
      ],
      popupRows,
      {
        delivery_challan_no: 'TOTAL',
        delivery_challan_date: '',
        delivery_challan_time: '',
        customer_name: '',
        site_name: '',
        grade: '',
        vehicle_no: '',
        dc_qty_display: formatQty(totalQty),
        actions: '',
      },
      'No delivery challans linked to this moisture correction.',
    ),
    width: '1100px',
    confirmButtonText: 'Close',
    didOpen: () => {
      attachPrintHandlers(cookies, '.mc-dc-print-btn', printDeliveryChallan, 'Delivery Challan', 'DC print failed');
      attachPrintHandlers(cookies, '.mc-br-print-btn', printBatchReport, 'Batch Report', 'BR print failed');
    },
  });
}
